import { ResidentialHistoryStatus } from '@api/btlApplicationForm/types';
import { countries } from '../../../ApplicationFormPage/Residency/countries';

export enum ResidencyStatus {
  BRITISH_CITIZEN = 'BRITISH_CITIZEN',
  EU_SETTLED_OR_PRE_SETTLED = 'EU_SETTLED_OR_PRE_SETTLED',
  INDEFINITE_LEAVE_TO_REMAIN = 'INDEFINITE_LEAVE_TO_REMAIN',
  SPOUSAL_VISA = 'SPOUSAL_VISA',
  OTHER = 'OTHER',
}

const RESIDENCY_STATUSES_REQUIRING_VISA_END_DATE = new Set<string>([
  ResidencyStatus.EU_SETTLED_OR_PRE_SETTLED,
  ResidencyStatus.SPOUSAL_VISA,
  ResidencyStatus.OTHER,
]);

export function doesResidencyStatusRequireVisaEndDate(status?: string | null): boolean {
  if (!status) {
    return false;
  }

  return RESIDENCY_STATUSES_REQUIRING_VISA_END_DATE.has(status);
}

export const ResidentialHistoryStatusLabels: Record<ResidentialHistoryStatus, string> = {
  [ResidentialHistoryStatus.OWNER_OCCUPIER]: 'Owner occupier',
  [ResidentialHistoryStatus.PRIVATE_RENT]: 'Renting from a private landlord or letting agent',
  [ResidentialHistoryStatus.COUNCIL_OR_HOUSING_ASSOCIATION]: 'Renting from a council or housing association',
  [ResidentialHistoryStatus.LIVING_WITH_PARENTS]: 'Living with parents',
  [ResidentialHistoryStatus.LIVING_WITH_FAMILY_OR_FRIENDS]: 'Living with other family or friends',
  [ResidentialHistoryStatus.OTHER]: 'Other',
};

export const RESIDENTIAL_STATUS_DESCRIPTION_MAX_LENGTH = 100;

export function doesResidentialHistoryStatusRequireDescription(status?: string | null): boolean {
  return status === ResidentialHistoryStatus.OTHER;
}

export function normalizeAddressHistoryResidentialStatus<
  T extends {
    residentialStatus?: ResidentialHistoryStatus | null;
    residentialStatusDescription?: string | null;
  },
>(entry: T): T {
  const residentialStatus = entry.residentialStatus ?? null;
  const residentialStatusDescription = doesResidentialHistoryStatusRequireDescription(residentialStatus)
    ? entry.residentialStatusDescription?.trim() || null
    : null;

  return {
    ...entry,
    residentialStatus,
    residentialStatusDescription,
  };
}

export enum TaxpayerType {
  UK_BASIC_RATE = 'UK_BASIC_RATE',
  COMPANY = 'COMPANY',
  UK_HIGHER_RATE = 'UK_HIGHER_RATE',
  NON_UK_TAXPAYER = 'NON_UK_TAXPAYER',
}

export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  CIVIL_PARTNERSHIP = 'CIVIL_PARTNERSHIP',
  SEPARATED = 'SEPARATED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
}

export const nationalitiesWithBritainAtStartAndOnlyOnce = countries
  .filter(val => val.value !== 'British')
  .map(val =>
    val.value === 'AAABritish'
      ? {
          value: 'British',
          label: 'British',
        }
      : val,
  );
